
export const getBanner = (isLogged, eventCategory, eventAction, items) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'event',
    'eventCategory': `${process.env.SKIN || 'webpremios'}:${eventCategory}-${isLogged ? 'logada' : 'aberta'}`,
    'eventAction': eventAction,
    'noInteraction': '1',
    'ecommerce': {
      'promoView': {
        'promotions': items
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/Shared/GTM/getBanner.js